import { z } from 'zod';
export const unitSchema = z.string().meta({ autocomplete: 'address-line2' });
